import React, { FC } from "react";
import styled from "styled-components";
import { externalLinkAttrs } from "~/lib/utils/urlHelper";
import { twoLineContent } from "~/styles/CommonStyles";

const SugowishStickyFooter: FC = () => {
  return (
    <Container id="sugowish-sticky">
      <Inner>
        <Text>第一印象がよくなる履歴書・職務経歴書を作ろう！</Text>
        <Text>👉</Text>
        <ButtonLink
          href="https://sugowish.com/doc/template"
          {...externalLinkAttrs("https://sugowish.com/doc/template")}
        >
          履歴書を作る
        </ButtonLink>
      </Inner>
    </Container>
  );
};

const Container = styled.div`
  background-color: var(--pri-bg-clr10);
  border-top: 1px solid var(--box-bdr-clr);
  bottom: 0;
  left: 0;
  position: fixed;
  width: 100%;
  z-index: 5;
`;

const Inner = styled.div`
  align-items: center;
  display: grid;
  justify-content: center;
  height: 72px;
  gap: 16px;
  grid-template-columns: auto 20px auto;
  margin: 0 auto;
  max-width: 720px;
  padding: 6px 16px;
  width: 100%;

  &:hover,
  &:active {
    opacity: 0.8;
    text-decoration: none;
  }

  @media only screen and (max-width: 440px) {
    gap: 8px;
  }
`;

const Text = styled.div`
  ${twoLineContent};
  color: var(--body-clr);
  font-size: 16px;
  font-weight: bold;
  line-height: 30px;
  text-align: left;

  @media only screen and (max-width: 440px) {
    font-size: 14px;
  }
  @media only screen and (max-width: 380px) {
    font-size: 13px;
  }
`;

const ButtonLink = styled.a`
  background: linear-gradient(90deg, #90cdf4 0%, #3182ce 100%);
  border-radius: 6px;
  color: #fff;
  display: block;
  font-size: 18px;
  font-weight: 700;
  height: 48px;
  line-height: 28px;
  padding: 10px 24px;

  &:hover {
    opacity: 0.8;
  }

  @media only screen and (max-width: 440px) {
    font-size: 16px;
    padding: 10px 16px;
  }

  @media only screen and (max-width: 380px) {
    font-size: 14px;
    padding: 10px 12px;
  }
`;

export default SugowishStickyFooter;
